import { observable, configure } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

class ConventionNoteStore extends LocalModel {
    constructor() {
        super('conventionNote', {
            namePlural: 'conventionNotes',
            namePluralReal: 'conventionnotes',
            sort: 'createdDate',
            limit: 100,
            api: {
                search: {
                    url: '/api/conventionnotes/',
                    params: {
                        limit: 100,
                        sort: 'createdDate',
                    },
                },
                load: {
                    url: '/api/conventionnotes/',
                    params: {},
                },
                save: {
                    url: '/api/conventionnotes/',
                    params: {},
                },
                delete: {
                    url: '/api/conventionnotes/',
                    params: {},
                },
            },
        });
    }

    @observable conventionNote = {};

    @observable conventionNotes = [];

    // Not observable: which convention the loaded list belongs to.
    loadedConvention = 0;

    getNoteForStage(stageMd5) {
        if (!stageMd5) {
            return null;
        }
        return this.conventionNotes.find(note => note.stage === stageMd5) || null;
    }

    // The API only ever returns the caller's own notes.
    async loadForConvention(conventionId) {
        const id = parseInt(conventionId, 10) || 0;
        if (!id) {
            return null;
        }
        const response = await util.fetchApi('/api/conventionnotes/', { method: 'GET' }, {
            convention: id,
        });
        if (response?.status === 200) {
            this.loadedConvention = id;
            this.updateKeyValue('conventionNotes', response.data || []);
        }
        return response;
    }

    async saveNote({ convention, stage, body }) {
        const response = await util.fetchApi('/api/conventionnotes/', { method: 'POST' }, {
            convention, stage, body,
        });
        if (response?.status === 201) {
            await this.loadForConvention(convention);
        }
        return response;
    }
}

const store = new ConventionNoteStore();

export default store;
